const SOURCE_PILLS = {
  default: { label: "Default", className: "title-tag-badge-muted" },
  user: { label: "Owner", className: "title-tag-badge" },
  org: { label: "Organization", className: "title-tag-badge" },
  blob: { label: "Blob", className: "title-tag-badge" },
  platform: { label: "Platform", className: "title-tag-badge-muted" },
};

const isEntry = (item) => item && 'object' === typeof item;

const limitsOf = (group) => (group && Array.isArray(group.limits) ? group.limits.filter(isEntry) : []);

/** The `<name>` of a `<family>.<name>` limit id. */
export function entryName(id) {
  const text = String(id);
  return text.slice(text.indexOf(".") + 1);
}

/** A type group's own `enabled` entitlement; undefined for a group that carries none. */
export function typeEnabled(group) {
  const found = limitsOf(group).find((item) => "enabled" === entryName(item.id));
  return found ? found.value : undefined;
}

/** The types a served `groups` list lets an organization create, as `{ value, label }` in served order. */
export function enabledTypes(groups) {
  if (!Array.isArray(groups)) return [];
  return groups
    .filter((group) => true === typeEnabled(group))
    .map((group) => ({ value: group.group, label: group.label }));
}

/** A group's entries in served order, with its fixed entries moved after the rest. */
export function orderedEntries(group) {
  const limits = limitsOf(group);
  return limits.filter((item) => !item.fixed).concat(limits.filter((item) => item.fixed));
}

/** The pill a limit's `source` wears, or null when it has none. */
export function sourcePill(source) {
  if (undefined === source || null === source) return null;
  if (Object.prototype.hasOwnProperty.call(SOURCE_PILLS, source)) return SOURCE_PILLS[source];
  return { label: String(source), className: "title-tag-badge-muted" };
}
